// dependencies
import { reducer } from "yarrr";
import { combineReducers } from "redux-immutable";

// router
// import { reducer } from '../App/routes';

// reducers
import ui from "./definitions/ui";
import app from "./definitions/app";
import users from "./definitions/users";
import toasts from "./definitions/toasts";
import company from "./definitions/company";
import deployments from "./definitions/deployments";
import notifications from "./definitions/notifications";

export default () =>
	combineReducers({
		ui,
		app,
		users,
		company,
		deployments,
		notifications: toasts,
		router: reducer,
		notificationSystem: notifications,
	});
